/**
 * BoxPlot / chart configs use `color().toLowerCase()` for groupField, which does not match
 * client-side row keys for SELECTIONS (stored as `selection`).
 */
export function performanceBoxPlotGroupField(color: string): string {
  if (color === 'SELECTIONS') return 'selection';
  if (color === 'RACE' || color === 'RACE_NUMBER') return 'race_number';
  return color.toLowerCase();
}
